// extracted by mini-css-extract-plugin
module.exports = {"relative":"StarcarMap_relative__xpfaD","absolute":"StarcarMap_absolute__lbtZH"};